module.exports = __webpack_public_path__ + "static/media/creature-desk.d11e4575.svg";